export default __webpack_public_path__ + "static/media/img11.62c48d1b.png";